<template>


  <div ref="vantaRef" style="background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(135deg, #f5e9ff -1%, #ffe9f4 100%);
  min-height: 100%;
  position: relative;
  display: block ">
<!--    <div-->
<!--    class="nav-bar"-->
<!--    >-->
<!--&lt;!&ndash;      <el-image class="nav-logo" @click="backOsredm" :src="osredmLogo" />&ndash;&gt;-->

<!--    </div>-->
    <div  class="container" >
<!--      <div class="banner-main" :style="{backgroundImage:'url('+require('../assets/new-banner.svg')+')'}" style=" background-size:cover; ">-->

      <div class="banner-main">
        <div class="banner-word">
<!--          <img src="../assets/hskylogo.png" style="height: 60px">-->

          <p class=" banner-f" >2025<br/>红山开源创新论坛</p>
          <p class="banner-s" >2025.08.02 中国·上海</p>



<!--          &lt;!&ndash;标签快速跳转&ndash;&gt;-->
<!--          <div class="div-jump">-->
<!--            <el-button round v-scroll-to="'#onlineTools'" class="button-jump">在线工具</el-button>-->
<!--            <el-button round v-scroll-to="'#lmTools'" class="button-jump">大模型工具集</el-button>-->
<!--            <el-button round v-scroll-to="'#opensourceModel'" class="button-jump">开源基座模型</el-button>-->
<!--            <el-button round v-scroll-to="'#devtools'" class="button-jump">开发工具套件</el-button>-->

<!--          </div>-->


        </div>
      </div>


      <div id="onlineTools" class="animate__animated animate__fadeInUp main-card">

        <div class="card-border">
          <el-card shadow="never"  >

              <p class="tools-title">参会报名</p>
              <p class="tips1" @click="noReg"></p>
              <p class="tips">注：报名成功后将自动为您注册为红山开源平台账号<br/>
<!--                <a href="/ActivityQuery">点击查询报名状态</a>-->
              </p>
              <p class="tips1" @click="noReg">无法收到验证码？注册失败？</p>
            <el-form :rules="rules" class="from-style" label-position="top"  :model="RegInfo">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="RegInfo.name" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="RegInfo.phone" @blur="validatePhone" >


                    <el-button v-if="registerOsredm" slot="suffix" @click="sendCode" :disabled="isSendingCode" class="custom-button">
                      {{ isSendingCode ? `${countdown}s后重试` : '发送验证码' }}
                    </el-button>

                </el-input>
              </el-form-item>
              <el-form-item  v-if="registerOsredm" label="验证码" prop="code">
                <el-input v-model="RegInfo.code"></el-input>
              </el-form-item>

              <el-form-item label="邮箱">
                <el-input v-model="RegInfo.email" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
              <el-form-item label="所属单位/公司">
                <el-input v-model="RegInfo.company" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
              <el-form-item label="职位">
                <el-input v-model="RegInfo.type" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
              <el-form-item  v-if="registerOsredm" label="设置密码" prop="password">
                <el-input type="password" v-model="RegInfo.password" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
              <el-form-item  v-if="registerOsredm" label="确认密码" prop="confirmPassword">
                <el-input type="password" v-model="RegInfo.confirmPassword" :disabled="isRegistrationClosed"></el-input>
              </el-form-item>
            </el-form>

            <el-button class="button" @click="submit" :disabled="isRegistrationClosed">
              报名
            </el-button>

            <div class="div1"></div>


          </el-card>


        </div>











      </div>





    </div>

    <el-backtop :visibility-height="200">
      <div style="height: 100%;
        width: 100%;
        background-color: rgb(255,243,251);
        border-radius: 10px;
        text-align: center;
        line-height: 40px;
        color: #da6cff;
        font-family: misans;
        font-size: 14px;
        font-weight: bold;
      "
      >
        返回
      </div>
    </el-backtop>
    <Footer></Footer>

  </div>

</template>

<script>

import pageUtils from "@/utils/pageUtils";
import Footer from "@/components/Footer"
import "../assets/font/font.scss";
import 'animate.css';

import * as Three from 'three';
import vantaFog from "vanta/src/vanta.fog";
import {Message} from "element-ui";
import md5 from 'md5';


export default {

  name: "ToolsHome",
  data(){
    return{

      isRegistrationClosed: false,
      RegInfo:{

        name:'',
        phone:'',
        code:0,
        company:'',
        type:'',
        password:'',
        confirmPassword:'',
        email:'',
        lotteryCode:'',
        regStatus:0,
      },

      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        password:[
            { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        code:[
            { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        confirmPassword:[
          { required: true, message: '请输入确认密码', trigger: 'blur' },
        ]
      },
      registerOsredm: true,

      osredmLogo: require("@/assets/logo/osredm-logo-black-new.png"),

      bingSearchUrl: 'https://cn.bing.com/search?q=' + this.searchInput,
      searchInput : '',
      buttonImgList : [
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
        require("@/assets/button-assets/tools-button-ns.svg"),
      ],
    }
  },


  methods:{

    noReg(){
      this.registerOsredm = false;
      // 0 已注册 1 未注册
      this.RegInfo.regStatus = 1;
      Message.success("您可以直接报名，稍后工作人员手动为您注册红山账号")
    },

    // 验证手机号的方法
    validatePhone() {
      const phone = this.RegInfo.phone;
      const phoneRegex = /^1[3-9]\d{9}$/; // 简单的手机号正则表达式
      if (phoneRegex.test(phone)) {
        // 手机号合规，调用 checkPhone 方法
        this.checkPhone();
      } else {
        // 手机号不合规，提示用户
        Message.error("请输入有效的手机号");
      }
    },

    checkPhone(){
      //TODO: 检测是否已经注册 如果已经注册就只保存在活动报名 系统当中就可以
      //TODO: 如果未注册 则同步注册红山用户
      // -2 已经注册 0未注册
      //https://www.osredm.com/api/accounts/valid_email_and_phone.json?login=15144444444&type=1
      return new Promise((resolve) => {
        this.$api.getValidPhone({
          login: this.RegInfo.phone,
          type: 1,
        }).then(res => {
          if (res.status === 0) {
            // 未注册
            this.RegInfo.regStatus = 0;
            resolve(true);
          } else if (res.status === -2) {
            Message.success("该手机号已经存在红山账号，您可直接进行活动报名");
            this.registerOsredm = false;
            // 0 已注册 1 未注册
            this.RegInfo.regStatus = 0;
            resolve(false);
          } else {
            // 与红山通信检测是否注册存在问题 直接报名 不注册红山账号
            Message.info("");
            this.registerOsredm = false;
            this.RegInfo.regStatus = 1;
            resolve(false);
          }
        });
      });
    },

    submit() {
      if (this.RegInfo.phone != "" && this.RegInfo.phone != "") {
        //生成一个UUID四位随机编码
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let lotteryCode = '';
        for (let i = 0; i < 4; i++) {
          lotteryCode += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        this.RegInfo.lotteryCode = lotteryCode;
        // 判断一下是否需要注册
        if (this.registerOsredm == false) {
          // 无需注册
          this.$api.regInsert(this.RegInfo).then(res => {
            console.log(res)
            if (res.status == 0) {
              this.$alert("您的抽奖编码为:" + this.RegInfo.lotteryCode +"此编码将作为抽奖的唯一标识", '活动报名成功', {
                confirmButtonText: '我已保存',

              });

            }else {
              Message.error("报名出错，请稍后再试 -1");
            }
          })
        }else {

          //需要注册红山
          // this.sendCode()

          if (this.RegInfo.code != 0){
            // 注册红山
            this.$api.regOsredm(
                {
                  code: this.RegInfo.code,
                  login: this.RegInfo.phone,

                  password: this.RegInfo.password,
                  // password_confirmation: this.RegInfo.confirmPassword
                }
            ).then(res => {
              console.log(res)
              if (res.status == 0) {
                this.$api.regInsert(this.RegInfo).then(res => {
                  console.log(res)
                  if (res.status == 0) {
                    this.$alert("您的抽奖编码为:" + this.RegInfo.lotteryCode +"此编码将作为抽奖的唯一标识", '活动报名成功', {
                      confirmButtonText: '我已保存',

                    });

                  }else {
                    Message.error("报名出错，请稍后再试 -2");
                  }
                })

              }else {
                Message.error("报名出错，请稍后再试 -3");
              }
            })
          }else {
            Message.info("请输入验证码")
          }


        }
      }
    },

    async sendCode() {

      //先测试一下 是否已经存在
      if (this.registerOsredm == true) {
        const needSend = await this.checkPhone();

        //还是会发验证码？？？

        console.log(needSend);
        if(needSend == true){
          var login = this.RegInfo.phone;
          var smscode = this.hashCode(this.RegInfo.phone);
          var type = 1;


          this.$api.sendCode({
            login,
            smscode,
            type,
          }).then(res => {
            console.log(res)
            if (res.status == -2) {
              Message.error("手机号接收超过频率限制");
            }
            Message.success("验证码已发送，请注意查收");
          })
        }
      }



    },
    hashCode(logins){
      const opens ="79e33abd4b6588941ab7622aed1e67e8";
      return md5(opens+logins);

    },
    handleSearch() {
      // 构建 Bing 搜索 URL
      const encodedQuery = encodeURIComponent(this.searchInput.trim());
      const bingUrl = `https://www.bing.com/search?q=${encodedQuery}`;

      console.log(this.searchInput)
      console.log(encodedQuery)
      console.log(bingUrl)
      // 跳转到新窗口
      window.open(bingUrl, '_blank');

      // 可选：清空输入框
      this.searchInput = '';
    },






    openUtilsPage(path){
      pageUtils.openPage(this.$router,path)
    },

    openWebPage(url){
      window.location.href=url;

    },

    // 返回红山开源
    backOsredm(){
      window.location.href='https://www.osredm.com';
    },
  },
  components:{
    Footer,

  },

  mounted() {

    const deadline = new Date(2025, 7, 2, 15, 30, 0); // 2025年8月2日14:00 (月份是0-based)
    const now = new Date();
    this.isRegistrationClosed = now > deadline;
    if (this.isRegistrationClosed === true) {
      Message.info("当前活动报名已经截止，感谢您的参与")
    }
    console.log(now)
    console.log(this.isRegistrationClosed)

    this.vantaEffect = vantaFog({
      el: this.$refs.vantaRef,
      THREE: Three
    })
    // 修改颜色时 cells 需要全大写字母 可生效
    vantaFog({
      el: this.$refs.vantaRef,
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      highlightColor: 0xffedf1,
      midtoneColor: 0xffedf1,
      lowlightColor: 0xFFD5FD,
      baseColor: 0xFFFEFF,
      blurFactor: 0.57,
      speed: 3.00,
      zoom: 1.40
    });
  }

}
</script>

<style scoped>


.tips{

  font-weight: 700;
  color: #aaaaaa;
}

.tips1{
  font-weight: 700;
  color: #3f63df;
  cursor: pointer;
}

.button{
  border-radius: 15px;
  background: linear-gradient(90deg, #A855F7 0%, #EC4899 100%);
  font-size: 16px;
  box-shadow: 0px 8px 30px 0px rgba(168, 85, 247, 0.2);

  color: #fff;

  width: 211px;
  height: 56px;
}

.from-style{


  .el-input /deep/.el-input__suffix{

    top: 5px;

    right: 8px;
  }



  .custom-button{
    border-radius: 10px;
    background: #5e73ff;
    color: #fff;

  }

  margin-top: 50px;

  padding-right: 50px;
  padding-left: 50px;
  /* 使用 Flexbox 布局 */
  display: flex;
  /* 允许换行 */
  flex-wrap: wrap;
  /* 控制子元素之间的间距 */
  column-gap: 60px;

  .el-form-item {
    /* 每个表单项占据大约 50% 的宽度，减去间距 */
    width: calc(50% - 30px);
  }

  text-align: left;
  .el-form-item /deep/.el-form-item__label{
    font-weight: 700;
    font-size: 18px;
    color: #2c3e50;
  }
  .el-form-item /deep/ .el-input__inner{
    width: 100%;
    height: 55px;
    border-radius: 16px;
    opacity: 1;

    /* 自动布局 */
    display: flex;


    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 0.75);

    box-sizing: border-box;
    border: 1px solid rgba(243, 232, 255, 0.5);

    backdrop-filter: blur(4px);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  }

}




.tools-title{

  font-size: 32px;
  font-weight: 800;

  /* 创建线性渐变背景 */
  background-image: linear-gradient(to right, #ac59f9, #ff30cf);

  /* 将背景裁剪到文字区域 */
  -webkit-background-clip: text;
  background-clip: text;
  /* 隐藏文字的默认填充颜色 */
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;


  text-align: center;
  margin: 0 auto;

  padding: 3px;


  width: 130px;


}


.container{


  margin:  0 auto;
  width: 1400px;
  padding-bottom: 18vh;
  display: flex;
  flex-direction: column;
  justify-content: center;    /* 垂直居中 */
  align-items: center;        /* 水平居中 */
}

.tools-card{

  /* 为需要过渡的属性添加过渡效果 */
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
  height 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
  border-radius 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
  color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
  margin 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
  box-shadow 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);



  display: flex;
  flex-direction: row;
  align-items: center;
  width: 288px;
  height: auto;
  border-radius: 15px;
  opacity: 1;
  color: black;
  margin: 30px 20px;
  /*float: left;*/

  cursor: pointer;
  user-select: none;
  draggable: false;
  border: 1px solid rgba(0, 0, 0, 0);

  box-shadow: 0px 4px 10px 0px rgba(118, 147, 204, 0.3);
}

.tools-card:hover{

  /* transform属性 */
  transform:translate(0,-10px);
  border: 1px solid #6816ff;

  height: auto;
  border-radius: 15px;
  color: #4b53ff;
  opacity: 1;
  margin: 30px 20px;
  /*float: left;*/

  cursor: pointer;
  user-select: none;
  draggable: false;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
}




.tools-text {

  font-size: 18px;
  font-weight: 700;
  text-align: left;
  top: 0px;

  margin-left: 10px;
  margin-bottom: 10px;
}


.tools-text1{

  font-size: 14px;
  font-weight: 500;
  width: 150px;
  /*color: #525561;*/
  text-align: left;

  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 18px;
}

.banner-main{
  position: relative;
  width: 95%;
  height: 350px;


  margin-top: 50px;
  border-radius: 20px;
}
.banner-img{

  width: 100%;


}

.banner-word{
  position: absolute;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(90deg, #9333EA 0%, #EC4899 50%, #2563EB 100%);







  /* 将背景裁剪到文字区域 */
  -webkit-background-clip: text;
  background-clip: text;
  /* 隐藏文字的默认填充颜色 */
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;


  font-family: Alibaba;
  font-weight: 500;
  top: 3%;
  left: 0;
  right: 0;


}


.card-border {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 40px;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

}

.card-border::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg at 50% 50%, transparent, #ff6ca4 14%, transparent 17%);

  animation: buttonBorderSpin 16s linear infinite;
}

.card-border::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(135deg, #fff0f2 -1%, #fff3ff 100%);

  border-radius: 15px;

}

@keyframes buttonBorderSpin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

::v-deep .el-card {
  position: relative;
  z-index: 1;
  border-radius: 15px;
  margin-bottom: 40px;
  border: none;
  background: transparent;
  box-sizing: border-box;
  padding: 20px;
}







a{
  color: #333;
  text-decoration:none;
}

a:link{
  color: #4154F1;
  text-decoration:none;
}

a:hover{
  color: #4154F1;
  text-decoration:none;
}

.search-fm{

  width: 500px;
  height: 40px;
  justify-content: center;
  text-align: center;
  display: flex;
  margin: 0 auto;
  border-radius: 25px;
  border: solid 1px #ddcdff;
  background: rgba(174, 166, 200, 0.11);
}

.search-input{
  width: 100%;
  margin:  0 10px ;
  font-size: 16px;
  font-weight: 550;
  background: transparent;
  border: none;
}

#btn_search{

  top: 0;
  right: 0;
  background: transparent;
  border: 0 !important;
  width: unset;
  height: unset;
  margin: 5px 10px 0 0;

  align-items: center;

  border-radius: 3px;
}

.banner-f{
  font-size: 68px;
  margin-bottom: 30px;
}
/* 二级标题 */
.banner-s{
  font-size: 25px;
}
/* 导航栏 */
.nav-bar{
  width: 1400px;
  height: 70px;
  display: flex;
  text-align: center;
  align-items: center;
  font-weight: 600;
  margin: 0 auto 20px;
}
/* 导航栏LOGO */
.nav-logo{
  margin-left:30px;
  margin-right: 50px;
  width: auto;
  height: 36px;
  cursor: pointer;
}
/* 导航栏首 */
.nav-f{
  margin-left: 20px;
}
/* 导航栏其他按钮 */
.nav-s{
  margin-left: 60px;
}

/* 主卡片 */
.main-card{
  width: 1400px;
  margin: 0 auto 0;
}

/* 工具描述 */
.tools-des{

  font-size: 16px;

  font-family: misans;
  font-weight: bold;
  margin: 30px 0 auto;


  /* 创建线性渐变背景 */
  background-image: linear-gradient(to right, #5800c3, #f80000);

  /* 将背景裁剪到文字区域 */
  -webkit-background-clip: text;
  background-clip: text;
  /* 隐藏文字的默认填充颜色 */
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;

}


/* 快速跳转按钮样式 */
.button-jump{
  font-size: 13px;
  font-weight: bold;
  font-family: misans;
  background: rgba(174, 166, 200, 0.11);
  padding: 6px 10px;

  border-color: #946cff;

  /* 创建线性渐变背景 */
  background-image: linear-gradient(to right, #c459f9, #5961f9);

  /* 将背景裁剪到文字区域 */
  -webkit-background-clip: text;
  background-clip: text;
  /* 隐藏文字的默认填充颜色 */
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

.div-jump{
  margin-bottom: 20px;
}

/* 移动端适配 */
@media screen and (max-width: 425px) {

  .tips{

    font-size: 12px;
    font-weight: 400;
    color: #aaaaaa;
  }

  .tips1{
    font-size: 12px;
    font-weight: 400;
    color: #3f63df;
    cursor: pointer;
  }
  .tools-title{

    font-size: 24px;
  }
  .from-style{


    .el-input /deep/.el-input__suffix{

      top: 6px;

      right: -115px;
    }



    .custom-button{
      border-radius: 10px;
      font-size: 12px;
      width: 100px;

      background: #5e73ff;
      color: #fff;

    }

    margin-top: 20px;

    padding-right: 20px;
    padding-left: 20px;
    /* 使用 Flexbox 布局 */
    display: flex;
    /* 允许换行 */
    flex-wrap: wrap;
    /* 控制子元素之间的间距 */
    column-gap: 5px;

    .el-form-item {
      /* 每个表单项占据大约 50% 的宽度，减去间距 */
      width: calc(50% - 2px);
    }

    text-align: left;
    .el-form-item /deep/.el-form-item__label{
      font-weight: 700;
      font-size: 14px;
      color: #2c3e50;
    }
    .el-form-item /deep/ .el-input__inner{
      width: 250px;
      height: 55px;
      border-radius: 16px;
      opacity: 1;

      /* 自动布局 */
      display: flex;


      background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 0.75);

      box-sizing: border-box;
      border: 1px solid rgba(243, 232, 255, 0.5);

      backdrop-filter: blur(4px);
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    }

  }





  .container{
    max-width: 1024px;
    min-width: 400px;
    margin:  0 auto;
    width: 400px;
    padding-bottom: 1vh;
    display: flex;
    flex-direction: column;
    justify-content: center;    /* 垂直居中 */
    align-items: center;        /* 水平居中 */
  }


  .banner-main{
    position: relative;
    width: 95%;
    height: 250px;


    border-radius: 20px;
  }

  /* 一级标题 */
  .banner-f{
    font-size: 38px;
  }
  /* 二级标题 */
  .banner-s{
    font-size: 20px;
  }



  /* 搜索 */
  .search-fm{

    width: 320px;
    height: 30px;
    justify-content: center;
    text-align: center;
    display: flex;
    margin: 0 auto;
    border-radius: 25px;
    border: solid 1px #ddcdff;
    background: rgba(174, 166, 200, 0.11);
  }

  .search-input{
    width: 100%;
    margin:  0 10px ;
    font-size: 14px;
    font-weight: 550;
    background: transparent;
    border: none;
  }

  #btn_search{

    top: 0;
    right: 0;
    background: transparent;
    border: 0 !important;
    width: unset;
    height: unset;
    margin: 1px 3px 0 0;

    align-items: center;

    border-radius: 3px;
  }




  /* 导航栏 */
  .nav-bar{
    max-width: 1024px;
    min-width: 400px;

    width: 400px;
    height: 70px;
    display: flex;
    text-align: center;
    align-items: center;
    font-weight: 600;
    margin: 0 auto 20px;
  }




  /* 导航栏LOGO */
  .nav-logo{
    margin-left:20px;
    margin-right: 20px;
    width: auto;
    height: 22px;
    cursor: pointer;
  }
  /* 导航栏首 */
  .nav-f{
    margin-left: 0px;
    font-size: 10px;
  }
  /* 导航栏其他按钮 */
  .nav-s{
    margin-left: 20px;
    font-size: 10px;
  }


  /* 主卡片 */
  .main-card{
    width: 380px;
    margin: 0 auto 0;
  }

}



@media screen and (max-width: 768px) {

  .tips{

    font-size: 12px;
    font-weight: 400;
    color: #aaaaaa;
  }

  .tips1{
    font-size: 12px;
    font-weight: 400;
    color: #3f63df;
    cursor: pointer;
  }
  .tools-title{

    font-size: 24px;
  }
  .from-style{


    .el-input /deep/.el-input__suffix{

      top: 6px;

      right: -115px;
    }



    .custom-button{
      border-radius: 10px;
      font-size: 12px;
      width: 100px;

      background: #5e73ff;
      color: #fff;

    }

    margin-top: 20px;

    padding-right: 20px;
    padding-left: 20px;
    /* 使用 Flexbox 布局 */
    display: flex;
    /* 允许换行 */
    flex-wrap: wrap;
    /* 控制子元素之间的间距 */
    column-gap: 5px;

    .el-form-item {
      /* 每个表单项占据大约 50% 的宽度，减去间距 */
      width: calc(50% - 2px);
    }

    text-align: left;
    .el-form-item /deep/.el-form-item__label{
      font-weight: 700;
      font-size: 14px;
      color: #2c3e50;
    }
    .el-form-item /deep/ .el-input__inner{
      width: 250px;
      height: 55px;
      border-radius: 16px;
      opacity: 1;

      /* 自动布局 */
      display: flex;


      background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 0.75);

      box-sizing: border-box;
      border: 1px solid rgba(243, 232, 255, 0.5);

      backdrop-filter: blur(4px);
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    }

  }





  .container{
    max-width: 1024px;
    min-width: 400px;
    margin:  0 auto;
    width: 400px;
    padding-bottom: 1vh;
    display: flex;
    flex-direction: column;
    justify-content: center;    /* 垂直居中 */
    align-items: center;        /* 水平居中 */
  }


  .banner-main{
    position: relative;
    width: 95%;
    height: 250px;


    border-radius: 20px;
  }

  /* 一级标题 */
  .banner-f{
    font-size: 38px;
  }
  /* 二级标题 */
  .banner-s{
    font-size: 20px;
  }









  /* 主卡片 */
  .main-card{
    width: 380px;
    margin: 0 auto 0;
  }

}
</style>
